import { addMinutes } from 'date-fns';

export const getTimezoneOffsetDate = (
    input: string | number | null,
): Date | null => {
    if (input === null) {
        return null;
    }

    const date = new Date(input);
    const timezoneOffset = date.getTimezoneOffset();

    return addMinutes(date, timezoneOffset);
};
